import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { templateParser } from 'utils/formatString';
import classNames from 'classnames/bind';

import {
  Popup,
  Heading,
  Checkbox,
  Button,
  HTML,
} from 'components';

import { getAutoProlongText } from '../../utils';

import AccumulatorProgressBar from '../AccumulatorProgressBar';
import AccumulatorInfo from '../AccumulatorInfo';
import BuyPackagesRow from '../BuyPackagesRow';
import ConnectionService from '../ConnectionService';

import styles from './styles.pcss';
import withServiceConnection from '../../hocs/withServiceConnection';

const cx = classNames.bind(styles);

const AccumulatorPopup = (props) => {
  const {
    onClose,
    progressBarLimits,
    acc,
    packages,
    content,
    connectServiceUrl,
    connectServicesUrl,
    connectionContent,
    onSetPending,
    initServiceConnection,
  } = props;
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isAutoProlongChecked, setIsAutoProlongChecked] = useState(false);
  const [isShowConnectionService, setIsShowConnectionService] = useState(false);

  const onOrderClick = () => {
    if (isAutoProlongChecked) {
      initServiceConnection(connectServicesUrl, { socs: [selectedPackage.soc, selectedPackage.socAutoProlong] });
    } else {
      initServiceConnection(connectServiceUrl, { soc: selectedPackage.soc });
    }
    setIsShowConnectionService(true);
  };
  const onPackageChange = (val) => {
    setSelectedPackage(val);

    if (!val) setIsAutoProlongChecked(false);
    else if (!selectedPackage && val && val.socAutoProlong) setIsAutoProlongChecked(true);
  };
  const onAutoProlonChange = () => setIsAutoProlongChecked((prev) => !prev);

  const onSuccess = () => {
    onClose();
  };

  return (
    <Popup opened onClose={onClose}>
      {isShowConnectionService ? (
        <ConnectionService
          onSuccess={onSuccess}
          onSetPending={onSetPending}

          onTimeoutBtnClick={onClose}
          onErrorBtnClick={onClose}
          content={connectionContent}
          serviceName={`${selectedPackage.value} ${selectedPackage.unit}`}
        />
      ) : (
        <>
          <Heading level={1} isStyled={false}>
            <HTML>{content.titles[packages.type.toLowerCase()]}</HTML>
          </Heading>
          <div className={cx('accumulatorWrap')}>
            {acc.isUnlimited ? (
              <HTML as="div" className={cx('unlimitedPackageTitle')}>
                {content.unlimitedAccTitles[acc.unit.toLowerCase()]}
              </HTML>
            ) : (
              <AccumulatorInfo acc={acc} />
            )}
            <AccumulatorProgressBar
              className={cx('progressBar')}
              progressBarLimits={progressBarLimits}
              acc={acc}
              fixedAccSizes={content.fixedAccSizes}
            />
            <HTML as="div" className={cx('accumulatorDescription')}>{content.accumulatorDescription}</HTML>
          </div>
          <div>
            <BuyPackagesRow
              title={content.buyPackagesTitle}
              titleClass={cx('packagesTitle')}
              packages={packages.parameters}
              onChange={onPackageChange}
            />
            {selectedPackage?.socAutoProlong && (
              <Checkbox
                name={`${selectedPackage.socAutoProlong}-package-autoprolong`}
                className={cx('checkbox')}
                checked={isAutoProlongChecked}
                handleChange={onAutoProlonChange}
              >
                <HTML>{getAutoProlongText(content.autoProlongCheckboxs, packages.type, selectedPackage)}</HTML>
              </Checkbox>
            )}
          </div>
          <div className={cx('btnWrap')}>
            <Button
              disabled={!selectedPackage}
              onClick={onOrderClick}
              type="button"
              className="big"
              wide
            >
              <HTML>
                {content.orderBtn}
                {selectedPackage
                  ? templateParser(content.orderBtnPostfix, { price: selectedPackage.priceValue })
                  : ''}
              </HTML>
            </Button>
          </div>
        </>
      )}
    </Popup>
  );
};

AccumulatorPopup.propTypes = {
  connectServiceUrl: PropTypes.string,
  connectServicesUrl: PropTypes.string,
  progressBarLimits: PropTypes.object,
  acc: PropTypes.shape({
    isUnlimited: PropTypes.bool,
    unit: PropTypes.string,
  }),
  packages: PropTypes.shape({
    type: PropTypes.string,
    parameters: PropTypes.array,
  }),
  content: PropTypes.object,
  connectionContent: PropTypes.object,
  onClose: PropTypes.func,
  onSetPending: PropTypes.func,
  initServiceConnection: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { connectServiceUrl, connectServicesUrl, yonth } = state.home.tariffServices.data.content;
  return {
    progressBarLimits: state.home.accumulators.data.progressBarLimits,
    connectServiceUrl,
    connectServicesUrl,
    connectionContent: yonth.connectionService,
  };
};

const AccumulatorPopupWithServiceConnection = withServiceConnection(AccumulatorPopup);

export default connect(mapStateToProps)(AccumulatorPopupWithServiceConnection);
